import type { CSSProperties } from "react";
import { colors, radius, spacing, typography } from "../../design-system";

export const iconWrapStyle: CSSProperties = {
  width: 38,
  height: 38,
  background: colors.brandSoft,
  borderRadius: radius.lg,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const thStyle: CSSProperties = {
  textAlign: "left",
  padding: "12px 20px",
  ...typography.labelUppercase,
  color: colors.textMuted,
  whiteSpace: "nowrap",
};

export const tdStyle: CSSProperties = {
  padding: "16px 20px",
  ...typography.body,
};

export const backButtonStyle: CSSProperties = {
  background: "none",
  border: "none",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  ...typography.bodySm,
  color: colors.textSecondary,
  padding: 0,
  fontFamily: typography.fontFamily,
};